import React from 'react';
import '../assets/ErrorMessage.css';

/**
 * ErrorMessage Component
 * 
 * Displays error messages with an icon, message text, and optional retry button.
 * Uses WCAG AA compliant colors for accessibility.
 * 
 * Requirements: 4.3, 8.2
 */
const ErrorMessage = ({ message, onRetry, showRetry = true }) => {
  // Sanitize message: use default if empty or whitespace-only
  const displayMessage = (message && message.trim()) 
    ? message 
    : 'An unexpected error occurred. Please try again.';
  
  return (
    <div className="error-message-container" role="alert" aria-live="assertive">
      <div className="error-icon" aria-hidden="true">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="22" stroke="#DC2626" strokeWidth="2" fill="#FEE2E2"/>
          <path d="M24 14v12M24 30v2" stroke="#DC2626" strokeWidth="3" strokeLinecap="round"/>
        </svg>
      </div>
      <div className="error-content">
        <h3 className="error-title">Something went wrong</h3>
        <p className="error-text">{displayMessage}</p>
        {showRetry && onRetry && (
          <button 
            className="error-retry-button" 
            onClick={onRetry}
            aria-label="Retry loading data"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path 
                d="M14 8A6 6 0 1 1 8 2c1.5 0 2.9.6 4 1.5M14 2v4h-4" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
            Try Again
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
